<template>
  <div class="car" ref="car">
    <img src="../../../assets/MyProgress/car.png" alt="car" />

    <img src="../../../assets/MyProgress/smoke.png" alt="smoke" class="smoke" />
  </div>
</template>

<script>
export default {
  props: {
    oldPosition: Number,
    newPosition: Number,
    currentPosition: Number,
    getPosition: Function,
    calcTiming: Function,
    linear: Function,
  },
  data() {
    return {
      car: null,
      positions: [
        { x: 75, y: 226, angle: 4 }, // 0
        { x: 138.75, y: 214, angle: 20 }, // 250
        { x: 202.5, y: 220, angle: 23 }, // 500
        { x: 266.25, y: 225, angle: 7 }, // 750
        { x: 330, y: 190, angle: -15 }, // 1000  0.018
        { x: 374, y: 170, angle: -20 },
        { x: 418, y: 130, angle: -10 },
        { x: 462, y: 110, angle: 10 },
        { x: 506, y: 105, angle: 14 },
        { x: 550, y: 103, angle: 14 }, // 2500  0.5
        { x: 579, y: 103, angle: 14 },
        { x: 608, y: 101, angle: 14 },
        { x: 638, y: 99, angle: 14 },
        { x: 667, y: 97, angle: 14 },
        { x: 697, y: 95, angle: 14 },
        { x: 726, y: 92, angle: 14 },
        { x: 755, y: 88, angle: 13 },
        { x: 784, y: 83, angle: 12 },
        { x: 814, y: 78, angle: 11 }, // 5000  1
        { x: 850, y: 64, angle: -10 },
      ],
    };
  },
  methods: {
    beforeFinishPositions(progress) {
      let positions = [
        { x: 850, y: -156, angle: -10 },
        { x: 870, y: -180, angle: -30 },
        { x: 870, y: -200, angle: -50 },
        { x: 880, y: -250, angle: -40 },
        { x: 910, y: -270, angle: -10 },
        { x: 920, y: -280, angle: 0 },
        { x: 940, y: -280, angle: 5 },
        { x: 960, y: -285, angle: 10 },
        { x: 980, y: -290, angle: 10 },
        { x: 1000, y: -295, angle: 10 },
        { x: 1013, y: -295, angle: -7 },
      ];

      let currentPoint; // Текущая точка
      let nextPoint; // Следующая точка
      let currentMark; // Для вычисления прогресса, относительно следующей точки
      let nextMark;

      switch (
        true // Массив возможных точек
      ) {
        case progress >= 1 && progress < 3:
          currentPoint = positions[0];
          nextPoint = positions[1];
          currentMark = 1;
          nextMark = 3;
          break;
        case progress >= 3 && progress < 4:
          currentPoint = positions[1];
          nextPoint = positions[2];
          currentMark = 3;
          nextMark = 4;
          break;
        case progress >= 4 && progress < 6:
          currentPoint = positions[2];
          nextPoint = positions[3];
          currentMark = 4;
          nextMark = 6;
          break;
        case progress >= 6 && progress < 8:
          currentPoint = positions[3];
          nextPoint = positions[4];
          currentMark = 6;
          nextMark = 8;
          break;
        case progress >= 8 && progress < 10:
          currentPoint = positions[4];
          nextPoint = positions[5];
          currentMark = 8;
          nextMark = 10;
          break;
        case progress >= 10 && progress < 12:
          currentPoint = positions[5];
          nextPoint = positions[6];
          currentMark = 10;
          nextMark = 12;
          break;
        case progress >= 12 && progress < 40:
          currentPoint = positions[6];
          nextPoint = positions[7];
          currentMark = 12;
          nextMark = 40;
          break;
        case progress >= 40 && progress < 100:
          currentPoint = positions[7];
          nextPoint = positions[8];
          currentMark = 40;
          nextMark = 100;
          break;
        case progress >= 100:
          currentPoint = positions[8];
          nextPoint = positions[9];
          currentMark = 100;
          nextMark = 9999999999999999999999999; // Чтобы не попасть на финиш
          break;
      }

      let onProcent = (nextMark - currentMark) / 100; // % между двумя точками
      let procentOfProgress = (progress - currentMark) / onProcent / 100;

      let newX =
        (nextPoint.x - currentPoint.x) * procentOfProgress + currentPoint.x;
      let newY =
        (nextPoint.y - currentPoint.y) * procentOfProgress + currentPoint.y;
      let newAngle =
        (nextPoint.angle - currentPoint.angle) * procentOfProgress +
        currentPoint.angle;

      let nextPointIndex = positions.indexOf(nextPoint);

      return [
        ...positions.slice(0, nextPointIndex),
        { x: newX, y: newY, angle: newAngle },
      ];
    },

    drivingBeforeFinish(progress) {
      const array = this.beforeFinishPositions(this.newPosition);
      let prog = Math.round(array.length * progress);

      this.car.style.transform = `translate3d(${array[prog].x}px, ${array[prog].y}px, 0) rotateZ(${array[prog].angle}deg)`;

      if (progress >= 0.9) getProgress(this.newPosition);
    },

    drivingCar(progress) {
      const array = this.positions;
      let step = array.length * progress; // Не округляем сразу

      let index = Math.round(step); // Ищем индекс первой точки

      let remainder = step - index; // Оставшаяся доля между точками

      this.centeringOnCar();

      setTimeout(() => {
        this.car.style.transition = "1s all linear";
      }, 500);

      if (index < array.length - 1) {
        // LERP (линейная интерполяция) для более плавного движения
        let x = this.lerp(array[index].x, array[index + 1].x, remainder);
        let y = this.lerp(array[index].y, array[index + 1].y, remainder);
        let angle = this.lerp(
          array[index].angle,
          array[index + 1].angle,
          remainder
        );

        this.car.style.transform = `translate3d(${x}px, ${y}px, 0) rotateZ(${angle}deg)`;
      } else {
        this.car.style.transform = `translate3d(850px, 55px, 0) rotateZ(-10deg)`; // Если вышли за пределы массива
        this.centeringOnCar();
      }
    },

    lerp(start, end, t) {
      return start + (end - start) * t;
    },

    animate({ duration, timing, draw, fn }) {
      let start = performance.now();
      let newPosition = this.newPosition;
      let oldPosition = this.oldPosition;

      requestAnimationFrame(
        function animate(time) {
          let timeFraction = (time - start) / duration + oldPosition;

          if (timeFraction > 1) timeFraction = 1;

          // вычисление текущего состояния анимации
          let progress = timing(timeFraction);

          if (fn) fn(progress); // передать прогресс родителю

          draw(progress); // отрисовать её

          if (timeFraction < 1 && timeFraction <= newPosition) {
            requestAnimationFrame(animate);
          }
        }.bind(this)
      );
    },

    centeringOnCar() {
      this.car.scrollIntoView({
        inline: "center",
        block: "center",
        behavior: "auto",
      });
    },

    startAnimation() {
      this.animate({
        duration: 20000,
        timing: this.calcTiming(this.linear),
        draw: this.drivingCar,
        fn: this.getProgress.bind(this),
      });
    },

    getProgress(progress) {
      this.$emit("changePosition", progress);
    },
  },
  watch: {
    currentPosition(newVal, prevValue) {
      /*
      if (newVal >= 1) {
        this.animate({
          duration: 5000,
          timing: this.calcTiming(this.linear),
          draw: this.drivingBeforeFinish,
        });
      }
        */
      //if (newVal >= this.newPosition) this.car.style.transition = "none";
    },
  },
  mounted() {
    this.car = this.$refs.car;

    this.car.style.transition = "none";

    setTimeout(() => {
      this.centeringOnCar();
    }, 200);

    if (this.currentPosition <= this.newPosition) this.startAnimation();
  },
};
</script>

<style scoped>
.car {
  pointer-events: none;
  position: absolute;
  bottom: 0;
  left: 0;
  z-index: 20;
  top: 270px;
  height: 134px;
  width: 134px;
}

.smoke {
  animation: smoke 1.5s infinite linear;
  display: block;
  height: 40px;
  position: absolute;
  top: 55px;
  left: -20px;
  transform: rotateZ(345deg);
}

@keyframes smoke {
  from {
    opacity: 1;
  }
  to {
    opacity: 0;
    left: -30px;
  }
}
</style>



// WEBPACK FOOTER //
// Content/src/components/MyProgress/Daccord/Car.vue